
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18C8.19722 16.0152 5.75238 14.7296 3.0954 14.3692C2.79298 14.3357 2.51367 14.1914 2.31139 13.9641C2.1091 13.7368 1.99818 13.4427 2.00002 13.1384V3.23063C2.00001 3.05286 2.03851 2.87719 2.11287 2.71572C2.18724 2.55424 2.2957 2.41079 2.43079 2.29524C2.56351 2.18179 2.71884 2.09787 2.88648 2.04906C3.05412 2.00026 3.23022 1.98768 3.4031 2.01216C5.94376 2.43383 8.26796 3.70002 10 5.60604V18Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 18C11.8028 16.0152 14.2476 14.7296 16.9046 14.3692C17.207 14.3357 17.4863 14.1914 17.6886 13.9641C17.8909 13.7368 18.0018 13.4427 18 13.1384V3.23063C18 3.05286 17.9615 2.87719 17.8871 2.71572C17.8128 2.55424 17.7043 2.41079 17.5692 2.29524C17.4365 2.18179 17.2812 2.09787 17.1135 2.04906C16.9459 2.00026 16.7698 1.98768 16.5969 2.01216C14.0562 2.43383 11.732 3.70002 10 5.60604V18Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    